import IncidentIcon from '@kinetic-ui/shared/lib/components/EventCategoryColumn/icons/IncidentIcon';
import PlannedEventIcon from '@kinetic-ui/shared/lib/components/EventCategoryColumn/icons/PlannedEventIcon';
import RoadCondition from '@kinetic-ui/shared/lib/components/EventCategoryColumn/icons/RoadCondition';
import WeatherIcon from '@kinetic-ui/shared/lib/components/EventCategoryColumn/icons/WeatherIcon';
import EventIcon from '@mui/icons-material/Event';
import { AppSearchIconKey } from '@kinetic-ui/shared';
import { EventCategory } from '@kinetic-ui/data-layer';

export const getAppSearchIconKey = (category?: EventCategory | null): AppSearchIconKey => {
  switch (category) {
    case EventCategory.Incident:
      return AppSearchIconKey.Incident;
    case EventCategory.PlannedEvent:
    case EventCategory.ScheduledEvent:
      return AppSearchIconKey.PlannedEvent;
    case EventCategory.Weather:
      return AppSearchIconKey.Weather;
    case EventCategory.RoadCondition:
      return AppSearchIconKey.RoadCondition;
    default:
      return AppSearchIconKey.Event;
  }
};

export const renderIcon = (category?: EventCategory | null) => {
  switch (category) {
    case EventCategory.Incident:
      return <IncidentIcon size='small' />;
    case EventCategory.PlannedEvent:
    case EventCategory.ScheduledEvent:
      return <PlannedEventIcon size='small' />;
    case EventCategory.Weather:
      return <WeatherIcon size='small' />;
    case EventCategory.RoadCondition:
      return <RoadCondition size='small' />;
    default:
      return <EventIcon />;
  }
};
